import {
    COP_API_BASE_URL,
    COUNTRIES_ENDPOINT,
    getCustomerUsersUrl,
    getSubscriptionByIdUrl,
    getSubscriptionSitesUrl,
    SUBSCRIPTIONS_ENDPOINT,
} from '../../../constants/service-endpoints';
import { fetchCustomersData } from '../../../services/customerSearch.service';
import { get, post, put } from '../../../services/http.service';

export interface Customer {
    id: string;
    name: string;
}

export interface Country {
    id: string;
    name: string;
}

export interface CustomerUser {
    id: number;
    email: string;
}

export interface CustomerSite {
    id: string;
}

export interface SubscriptionPayload {
    country: string;
    customerId: string;
    customerUserIds: number[];
    siteIds: string[];
    type: string;
}

export interface SubscriptionDetail {
    id: string;
    customerId: string;
    customerName?: string;
    type: string;
    country: string;
    customerEmailAddresses?: string[];
    customerUserIds: number[];
    siteIds: string[];
}

export async function fetchCustomers(searchTerm?: string, skip = 0): Promise<Customer[]> {
    const data = await fetchCustomersData<Customer>({
        cacheKeyPrefix: 'subscription:customers',
        searchTerm,
        skip,
        top: 50,
    });
    return data.value ?? [];
}

export async function fetchCountries(): Promise<Country[]> {
    const data = await get<Record<string, string>>(`${COP_API_BASE_URL}${COUNTRIES_ENDPOINT}`);
    if (!data || typeof data !== 'object' || Array.isArray(data)) return [];
    return Object.entries(data).map(([code, name]) => ({ id: code, name }));
}

export async function fetchCustomerUsers(customerId: string): Promise<CustomerUser[]> {
    const data = await get<{ value: CustomerUser[] }>(`${COP_API_BASE_URL}${getCustomerUsersUrl(customerId)}`);
    return data.value ?? [];
}

export async function fetchCustomerSites(customerId: string): Promise<CustomerSite[]> {
    const data = await get<{ value: CustomerSite[] }>(`${COP_API_BASE_URL}${getSubscriptionSitesUrl(customerId)}`);
    return data.value ?? [];
}

export async function addSubscription(payload: SubscriptionPayload): Promise<void> {
    await post(`${COP_API_BASE_URL}${SUBSCRIPTIONS_ENDPOINT}`, payload);
}

export async function fetchSubscriptionById(id: string): Promise<SubscriptionDetail | null> {
    const data = await get<{ value: SubscriptionDetail[] }>(`${COP_API_BASE_URL}${getSubscriptionByIdUrl(id)}`);
    return data.value?.[0] ?? null;
}

export async function updateSubscription(id: string, payload: SubscriptionPayload): Promise<void> {
    await put(`${COP_API_BASE_URL}${SUBSCRIPTIONS_ENDPOINT}/${id}`, payload);
}
